/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { CardWrapper, BoxButton } from 'pages/Documents/HelpModal/styles';

// Modal de Ajuda
const HelpModal = ({ onClose }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef}>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Title secondary>
        Sobre a atermação
      </Title>
      <Text>
        Você contratou o serviço de atermação que é realizado pela equipe da LOIT juntamente com você.
      </Text>
      <Text>
        Precisamos interagir para a troca das informações e documentos necessários para completar o procedimento.
      </Text>
      <Text>Ao final você receberá a numeração do seu processo na justiça através do qual poderá acompanhar seu andamento no futuro.</Text>
      <Text>Fique atento ao seu e-mail e/ou WhatsApp para novas informações.</Text>
      <BoxButton>
        <Button onClick={() => {
          window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace('/', '')}`);
          window.Intercom('show');
          onClose(false);
        }}
        >
          Iniciar conversa com o suporte
        </Button>
      </BoxButton>
    </CardWrapper>
  );
};

HelpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default HelpModal;
